import { createContext } from 'react';
import { IServerError, ISerialNumberExistsValidationError, IUpdateWatch } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface IEditWatchState {
	needRefetchData: boolean;
	isLoading: boolean;
	watchID: string;
	serialNumber: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	dataForSubmit: Nullable<IUpdateWatch>;
	isActive: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: Nullable<IServerError<ISerialNumberExistsValidationError>>;
}

export const editWatchInitialState: IEditWatchState = {
	needRefetchData: false,
	isLoading: true,
	watchID: '',
	serialNumber: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	dataForSubmit: null,
	isActive: false,
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface IEditWatchContext extends IEditWatchState {
	refetchData(value: boolean): void;
	changeLoaderStatus(value: boolean): void;
	changeSerialNumber(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setDataForSubmit(value: Nullable<IUpdateWatch>): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: Nullable<IServerError<ISerialNumberExistsValidationError>>): void;
}

export const EditWatchContext = createContext<IEditWatchContext>({
	refetchData: () => undefined,
	changeLoaderStatus: () => undefined,
	changeSerialNumber: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	...editWatchInitialState,
});
